import React from 'react';

// interface Props {
//   images: { src: string; alt: string; title: string }[];
// }

const images = [
  {src: 'https://naendapi.naecoaching.com/media/images/Mysterious_sci-fi_illustrated_science_fiction_movie_poster_1.png', alt: 'seasonal1', title: 'Haldi Rasam'},
  {src: 'https://naendapi.naecoaching.com/media/images/Blue_and_Green_Illustrative_4_Tips_to_Protect_Biodiversity_Poster.png', alt: 'seasonal2', title: 'Mehandi Rasam'},
  {src: 'https://naendapi.naecoaching.com/media/images/Green_and_Blue_Illustrative_Climate_Change_Poster.png', alt: 'seasonal3', title: 'Bridal Dresss'},
  {src: 'https://naendapi.naecoaching.com/media/images/Mysterious_sci-fi_illustrated_science_fiction_movie_poster.png', alt: 'seasonal4', title: 'Saraaraa'}
  
]

const Language4Ad: React.FC = () => { ///<Props> = ({ images }) => {
  return (
    <div className="container mx-auto">
      <h2 className="text-2xl font-bold text-center my-8">Learn Language ☀️</h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {images.map((image, index) => (
          <div key={index} className="relative group">
            <img
              src={image.src}
              alt={image.alt}
              className="w-full rounded-md object-cover hover:scale-105 md:hover:scale-110 hover:z-2 hover:shadow-lg "
            />
            {/* <div className="absolute bottom-4 left-4 bg-black bg-opacity-50 rounded-md px-4 py-2 text-white text-center group-hover:opacity-100 transition duration-300 ease-in-out">
              <span className="font-bold">{image.title}</span>
            </div> */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Language4Ad;